import { useState } from 'react'
import { useNavigate } from 'react-router'
import { EmptyState, ErrorState, OrgChart, PageHeader } from '@/components/common'
import { Card } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useBreadcrumb } from '@/hooks/useBreadcrumb'
import { useOrgChart } from '../api'

/** Who reports to whom, from the roots down. */
export function OrgChartPage() {
  useBreadcrumb()
  const navigate = useNavigate()
  const [depth, setDepth] = useState(3)
  const chart = useOrgChart(depth)

  return (
    <div className="space-y-4">
      <PageHeader
        title="Org structure"
        subtitle="The reporting line. Search keeps a match's managers, because a name with no context answers nothing."
      />

      <Card className="p-4">
        {chart.isPending && <Skeleton className="h-64" />}
        {chart.isError && <ErrorState error={chart.error} onRetry={() => void chart.refetch()} />}
        {chart.isSuccess && chart.data.length === 0 && (
          <EmptyState
            title="Nobody has a manager yet"
            description="The chart is drawn from each person's reporting line. Once managers are set on assignments, it appears here."
          />
        )}
        {chart.isSuccess && chart.data.length > 0 && (
          <OrgChart
            roots={chart.data}
            onSelect={(id) => { void navigate(`/employees/${id}`) }}
            // The server sends a bounded depth; opening past it asks for more rather than
            // pretending the branch is empty.
            onExpandBeyondDepth={() => setDepth((current) => Math.min(current + 2, 5))}
          />
        )}
      </Card>
    </div>
  )
}
